import { get } from '../apiService';

export const downloadResourceMatrixFile = async (
  fileContent: string
): Promise<{ url: string; loading: boolean }> => {
  const baseUrl =
    'https://gateway-bso7uhc0.wl.gateway.dev/resourceMatrixDownload';
  const queryParams = `file=${encodeURIComponent(fileContent)}`;
  const fullUrl = `${baseUrl}?${queryParams}`;

  let loading = true;
  let fileUrl = '';

  try {
    fileUrl = await get(fullUrl);
    loading = false;
    return { url: fileUrl, loading };
  } catch (error) {
    console.error('Failed to download resource matrix file:', error);
    throw new Error('Failed to download resource matrix file');
  }
};
